<template>
  <div>
    <div class="relative">
      <div class="w-full max-w-full video-grid-columns">
        <AthleteVideoCard
          v-for="video in shownVideos"
          :key="video.id"
          :video="video"
          class="video-fade-in"
          style="--vid-card-width: 200px;"
        />
      </div>

      <GradientFade
        v-if="isOverflowing"
        direction="bottom"
        :size="50"
        endColor="rgba(240,241,243,1)"
      />
    </div>
    <div class="flex flex-row">
      <a
        class="cursor-pointer text-blue-300 block mt-4"
        v-if="isOverflowing"
        @click="moreVideos"
      >See More Videos</a>
      <div class="mt-4 mx-4 text-gray-600" v-if="isExpanded && isOverflowing">|</div>
      <a
        class="cursor-pointer text-blue-300 block mt-4"
        v-if="isExpanded"
        @click="lessVideos"
      >See Less Videos</a>
    </div>
  </div>
</template>

<script>
import AthleteVideoCard from "./VideoCard.vue";
import GradientFade from "@/components/GradientFade";

export default {
  components: {
    AthleteVideoCard,
    GradientFade
  },

  props: {
    videos: { type: Array, required: true }
  },

  data() {
    return {
      initialShownCount: 12,
      isExpanded: false,
      pagedCount: 1
    };
  },

  computed: {
    shownVideos() {
      return this.isExpanded
        ? this.videos.slice(0, this.totalCount)
        : this.videos.slice(0, this.initialShownCount);
    },

    isOverflowing() {
      return this.videos.length > this.totalCount;
    },
    totalCount() {
      return this.pagedCount * this.initialShownCount;
    }
  },
  methods: {
    moreVideos() {
      this.isExpanded = true;
      this.pagedCount++;
    },
    lessVideos() {
      this.isExpanded = false;
      this.pagedCount = 1;
      window.scrollTo(0, document.querySelector("#videoLabel").offsetTop - 80);
    }
  }
};
</script>

<style lang="scss">
.video-grid-columns {
  display: grid;
  grid-gap: 24px;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
}
@keyframes fadein {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.video-fade-in {
  animation: fadein 0.5s ease-out forwards;
}
</style>
